import Vue from 'vue';
import App from './modules/shared/shared/views/App.vue';
import router from './modules/shared/shared/router';
import store from './modules/shared/shared/store';
import vuetify from './plugins/vuetify';
import JsonExcel from 'vue-json-excel';
import ability from './plugins/acl/ability';
import { abilitiesPlugin } from '@casl/vue';
import { activityDetector } from '@/plugins/activity-detector';
activityDetector.init();
const VueTheMask = require('vue-the-mask').default;
Vue.use(abilitiesPlugin, ability);
Vue.config.productionTip = false;
const VueUploadComponent = require('vue-upload-component');
Vue.component('file-upload', VueUploadComponent);

export const EventBus = new Vue();

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App),
}).$mount('#app');

Vue.use(VueTheMask);
Vue.component('downloadExcel', JsonExcel);
